<template>
  <v-container grid-list-md text-center>
    <v-layout wrap>
      <v-flex xs6>
        <v-card>
          <v-card-text class="px-5">
            <v-form @submit.prevent data-vv-scope="form" lazy-validation>
              <v-layout column wrap>
                <v-flex xs12 md4>
                  <v-select
                    :items="users"
                    name="User"
                    label="Pilih User"
                    v-model="tukarShift.user_id1"
                    hint="User"
                    type="number"
                    data-vv-name="user"
                    data-vv-as="user"
                    v-validate="'required'"
                    item-text="nama"
                    item-value="user_id"
                    :error-messages="errors.collect('form.user')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    :items="periodes"
                    name="Periode"
                    label="Pilih Periode"
                    hint="Periode"
                    v-model="tukarShift.periode"
                    type="number"
                    data-vv-name="periode"
                    data-vv-as="periode"
                    v-validate="'required'"
                    item-text="periode"
                    item-value="id"
                    :error-messages="errors.collect('form.periode')"
                  ></v-select>
                </v-flex>
                <v-flex>
                  <v-btn depressed class="ma-0 mt-3" color="primary">Jadwal Kerja</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card>
          <v-card-text class="px-5">
            <v-form @submit.prevent data-vv-scope="form" lazy-validation>
              <v-layout column wrap>
                <v-flex xs12 md4>
                  <v-select
                    :items="users"
                    name="User"
                    label="Pilih User"
                    v-model="tukarShift.user_id2"
                    hint="User"
                    type="number"
                    data-vv-name="user"
                    data-vv-as="user"
                    v-validate="'required'"
                    item-text="nama"
                    item-value="user_id"
                    :error-messages="errors.collect('form.user')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    :items="periodes"
                    name="Periode"
                    label="Pilih Periode"
                    v-model="tukarShift.periode"
                    hint="Periode"
                    type="number"
                    data-vv-name="periode"
                    data-vv-as="periode"
                    v-validate="'required'"
                    item-text="periode"
                    item-value="id"
                    :error-messages="errors.collect('form.periode')"
                  ></v-select>
                </v-flex>
                <v-flex>
                  <v-btn depressed class="ma-0 mt-3" color="primary">Tukar Jadwal</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tukarShift: {},
      users: [],
      periodes: [
        {
          id: 1,
          periode: "MEI 2019",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.getAllUser();
  },
  methods: {
    getAllUser() {
      this.$store.dispatch("user/get").then((res) => {
        this.users = res.data;
      });
    },
  },
};
</script>
